import { render } from "./create.vue?vue&type=template&id=cbdf390c&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"

import "./create.vue?vue&type=style&index=0&id=cbdf390c&scoped=true&lang=css"

import exportComponent from "/var/www/gapp-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbdf390c"]])

export default __exports__